"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { consentAnswered, setConsent } from "@/lib/consent";

export default function Consent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(!consentAnswered());
    const reopen = () => setShow(true);
    window.addEventListener("lw:open-consent", reopen);
    return () => window.removeEventListener("lw:open-consent", reopen);
  }, []);

  if (!show) return null;
  const answer = (granted) => { setConsent(granted); setShow(false); };

  return (
    <div className="consent" role="dialog" aria-labelledby="consent-title" aria-describedby="consent-text">
      <h2 id="consent-title">Cookies at Lulu&rsquo;s</h2>
      <p id="consent-text">
        We use Google Analytics and Google Ads to understand how the site is used. With your OK we
        also use Meta for marketing. Decline and we switch the advertising cookies off.{" "}
        <Link href="/privacy-policy/">Privacy policy</Link>
      </p>
      <div className="btn-row">
        <button className="btn btn--solid" onClick={() => answer(true)}>Accept</button>
        <button className="btn" onClick={() => answer(false)}>Decline</button>
      </div>
    </div>
  );
}
